import { languageCodes } from './config';

export class BackendError extends Error {
    constructor(message) {
        super(message);
        this.name = 'BackendError';
    }
}

const convertTableValue = (value, numCols) => {
    // // let strValue = typeof value ===  'number' ? value.toString() : value;
    // if (typeof value !== 'string') {
    //     console.log('value:', value);
    //     return [];
    // }
    return value.split(';').map(
        (rowStr) => {
            const rowArray = rowStr.trim().split(' ');
            // make sure each row has nCols values
            for (let index = rowArray.length; index < numCols; index++) {
                rowArray[index] = '';
            }
            return rowArray;
        }
        // .map((strVal) => parseInt(strVal, 10))
    );
};

const revertTableValue = (val) => {
    return val.map((row) => row.join(' ')).join(';');
};

const convertValue = (value, paramConfig, forceObject = false) => {
    if (paramConfig) {
        if (paramConfig.control === 'table' && value) {
            // "2 0; 10 5" => [[2,0],[10,5]]
            const numCols = 2;
            if (
                typeof value === 'object' &&
                value !== null &&
                value.hasOwnProperty('value')
            ) {
                return {
                    ...value,
                    value: convertTableValue(value.value, numCols),
                    orgValue: value,
                    revertValue: (val) => {
                        const { revertValue, orgValue, ...valueParams } = val;
                        return {
                            ...valueParams,
                            value: revertTableValue(val.value),
                        };
                    },
                };
            }
            if (forceObject) {
                return {
                    value: convertTableValue(value, numCols),
                    orgValue: value,
                    revertValue: (val) => {
                        const { revertValue, orgValue, ...valueParams } = val;
                        return {
                            ...valueParams,
                            value: revertTableValue(val.value),
                        };
                    },
                };
            }
            return {
                value: convertTableValue(value, numCols),
                orgValue: value,
                revertValue: (val) => revertTableValue(val.value),
            };
        }
    }
    return value;
};
export function convertGameData(game, config) {
    if (!game || !config) {
        return game;
    }
    const converted = Object.keys(game).reduce(
        (attrs, key) => ({
            ...attrs,
            [key]: convertValue(game[key], config[key]),
        }),
        {}
    );
    return converted;
}

export function convertConfig(config) {
    if (!config) {
        return config;
    }

    return Object.keys(config).reduce(
        (attrs, key) => ({
            ...attrs,
            [key]: {
                ...config[key],
                default: convertValue(config[key].default, config[key], true),
            },
        }),
        {}
    );
}

export function beforeSaveGame(game) {
    if (!game) {
        return game;
    }

    const convertedGame = Object.keys(game).reduce((attrs, key) => {
        const value = game[key];
        let revertedValue;
        if (typeof value === 'object' && value !== null && value.revertValue) {
            revertedValue = value.revertValue(value);
        } else {
            revertedValue = value;
        }
        return {
            ...attrs,
            [key]: revertedValue,
        };
    }, {});

    return JSON.stringify(convertedGame);
}

export function getHelpUrl(paramUrl, gameConfig, language) {
    if (!paramUrl) return null;
    if (paramUrl.startsWith('http')) return paramUrl;
    if (!gameConfig) return null;

    const baseHelpUrl = gameConfig?.['@help']?.helpurl || '.';
    const urlLang = languageCodes[language || 0];
    return `${baseHelpUrl}/${urlLang}/${paramUrl}`;
}
